import { Inject, Injectable, Optional } from '@angular/core';
import { Observable, from } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import {
  ACCEPTED_IMAGE_FORMATS,
  ConfigService,
  EntityService,
  QualityImage,
  TokenService
} from 'viggo-sistemas-core-web';
import { IProdutoVariacao } from '../../model';

interface DownloadConfig {
  imagemId: string;
  quality?: QualityImage;
  mapToBase64?: boolean;
}

@Injectable()
export class ProdutoVariacaoService extends EntityService<IProdutoVariacao> {
  protected acceptedImageFormats: string[] = [];

  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService,
    @Optional() @Inject(ACCEPTED_IMAGE_FORMATS) acceptsImageFormats: string[]
  ) {
    super({
      baseEntityEndPoint: 'produto_variacoe',
      urlBackend: configService.backendURL
    });

    if (acceptsImageFormats && Array.isArray(acceptsImageFormats))
      this.acceptedImageFormats = acceptsImageFormats;
    else this.acceptedImageFormats = ['jpeg', 'jpg', 'png', 'gif'];
  }

  /**
   * Adciona uma imagem ao produto
   * @param produtoVariacaoId identificador do produto
   * @param imagem
   */
  public addImagem(
    produtoVariacaoId: string,
    imagem: File
  ): Observable<IProdutoVariacao> {
    const url = `${this.baseURL}/${produtoVariacaoId}/imagens`;
    const formData = new FormData();
    formData.append('file', imagem, imagem.name.toLowerCase());
    const headers = this.getHeader().delete('Content-Type');

    return this.http
      .post<{ produto_variacao: IProdutoVariacao }>(url, formData, {
        headers
      })
      .pipe(map(({ produto_variacao }) => produto_variacao));
  }

  /**
   * Remove a imagem de um produto
   * @param produtoVariacaoId identificador do produto
   */
  public removerImagem(produtoVariacaoId: string) {
    const url = `${this.baseURL}/${produtoVariacaoId}/imagens`;

    return this.http.delete(url, { headers: this.getHeader() });
  }

  // FUNÇÕES DO IMAGEM SERVICE QUE POR ALGUM MOTIVO NÃO CONSEGUIU IDENTIFICAR
  // O CAMINHO DO CONFIGSERVICE

  /**
   * Transforma uma string em um valor base64
   * @param file Arquivo a ser transformado
   */
  public loadBlobToBase64(file: Blob): Observable<string> {
    const promise = new Promise<string>((resolve, reject) => {
      const fileReader = new FileReader();

      fileReader.onloadend = () => resolve(`${fileReader.result}`);

      fileReader.onerror = () => reject(fileReader.error);

      fileReader.readAsDataURL(file);
    });
    return from(promise);
  }

  /**
   * Valida se uma imagem é válida para ser adicionada no backen
   * @param file Arquivo a ser validado
   */
  public validImagemFile(file: File): boolean {
    if (!file.name) return false;
    const aceptedFormats = this.acceptedImageFormats.join('|');
    const regexFormats = `^.*\\.(${aceptedFormats})$`;
    return !!file.name.match(regexFormats);
  }
  /**
   * Retorna um array com as informações de formatos aceitos
   */
  public getAcceptsFormats(): string[] {
    return this.acceptedImageFormats;
  }

  /**
   * Baixa uma imagem que está salva no root do viggo-core
   * @param config configuracoes da request
   */
  public donwloadImagem({
    imagemId,
    quality = 'med',
    mapToBase64 = true
  }: DownloadConfig): Observable<Blob | string> {
    const url = `${this.baseURL}/${imagemId}?quality=${quality}`;

    return this.http
      .get(url, {
        responseType: 'blob'
      })
      .pipe(
        mapToBase64 &&
          mergeMap((blobFile: Blob) => this.loadBlobToBase64(blobFile))
      );
  }
}
